import { render, staticRenderFns } from "./contribute-form.vue?vue&type=template&id=52454ac6&scoped=true"
import script from "./contribute-form.vue?vue&type=script&lang=js"
export * from "./contribute-form.vue?vue&type=script&lang=js"
import style0 from "./contribute-form.vue?vue&type=style&index=0&id=52454ac6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52454ac6",
  null
  
)

export default component.exports